export interface Urns {
  urn: string;
  refId: number;
  spaceTypeId: number;
  siteDrawingTypeId: number;
}
